
define('text!presentation/common/snackbar/views/freeTrialMessagingSnackbar.html',[],function () { return '<div data-bind="snackbar: {\n                    isWarningSnackbar: true\n                }">\n    <div data-part="left-content">\n        <span data-bind="i18n: $parent.messageKey"/>\n    </div>\n</div>\n';});

